import dataApplicationsContext from "../../../context/dataApplicationsContext"
import { useContext } from 'react';
import UserGoBack from "../../user/UserGoBack";
import ArticleUtile from "../ArticleUtile";
import RightPartContent from "../RightPartContent";
import { useTopic } from "../../../hooks/useTopic";

const HelpTopicRecentConnexions = () => {
  const { windowWidth } = useContext(dataApplicationsContext);
  const { topic, isLoading, LoadingComponent } = useTopic();
  if (isLoading) return <LoadingComponent />;

  const isSmallDevise = windowWidth < 900;  

  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: 'Votre compte', link: '/topics/compte'},
    { label: 'Sécurité du compte', link: '/topics/compte/securite'},
    { label: topic.title, link: topic.link},
  ]

  return (
    <div className="user-setting-container help">
      <UserGoBack
        goBackLinks={goBackLinks} isSmallDevise={isSmallDevise} guideInfo={topic.slug} titleClass='mb-0 w-help-title'
      />
      <div className="help-content-container mt-32">
        <div className="help-content-flex mb-80">
          <div className="help-left-part">
            <p className="help-text">
              Vous voulez en savoir plus sur vos précédentes connexions ?
              Rendez-vous dans <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/account-settings`}>Compte,</a> puis sélectionnez <strong>Connexion et sécurité. </strong> 
              Sous <strong>Historique de l'appareil,</strong> vous pourrez consulter la liste des connexions 
              à votre compte Wodzone, avec notamment les informations suivantes :
            </p>
            <ul className="mb-6">
              <li className="pl-8 mb-12"><p className="help-text">Le navigateur ou l'appareil concerné</p></li>
              <li className="pl-8 mb-12"><p className="help-text">L'heure de connexion</p></li>
              <li className="pl-8 mb-12"><p className="help-text">Le lieu de connexion</p></li>
            </ul>
            <ArticleUtile id_topic={topic.id_topic}/>
          </div>
          <RightPartContent />
        </div>
      </div>
    </div>
  )
}

export default HelpTopicRecentConnexions